export default "__VITE_ASSET__DyfiVWUg__"